<template>
  <div class="page-setting-personal-password">
    <app-page-box title="修改密码" v-if="currentStep === 0" key="0">
      <el-form class="page-setting-personal-password__form" :model="form" :rules="rules" ref="form" label-width="108px" status-icon>
        <el-form-item label="原密码" prop="oldPassword" size="small">
          <el-input type="password" v-model="form.oldPassword" placeholder="请输入原密码" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword" size="small">
          <el-input type="password" v-model="form.newPassword" placeholder="请输入新密码" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword" size="small">
          <el-input type="password" v-model="form.confirmPassword" placeholder="请再次输入新密码" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item size="small">
          <el-button type="primary" @click="handleBtnSubmitClick">保存</el-button>
        </el-form-item>
      </el-form>
    </app-page-box>
    <app-page-box title="修改密码" v-else-if="currentStep === 1" key="1">
      <div class="page-setting-personal-password__success">
        <app-svg-icon icon-class="success"></app-svg-icon>
        <span>修改密码成功，请重新登录！</span>
      </div>
    </app-page-box>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'
import { validatePassword } from '@/utils'

export default {
  name: 'SettingPersonalPassword',
  components: {
    AppPageBox
  },

  data () {
    const validateNewPassword = (rule, value, callback) => {
      const { confirmPassword } = this.form

      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (!validatePassword(value)) {
        callback(new Error('密码格式为 6-16 位数字及字母组成，不能含有特殊字符'))
      } else if (confirmPassword && value !== confirmPassword) {
        callback(new Error('两次输入密码不一致，请重新输入'))
      } else {
        callback()
      }
    }

    const validateConfirmPassword = (rule, value, callback) => {
      const { newPassword } = this.form

      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (!validatePassword(value)) {
        callback(new Error('密码格式为 6-16 位数字及字母组成，不能含有特殊字符'))
      } else if (newPassword && value !== newPassword) {
        callback(new Error('两次输入密码不一致，请重新输入'))
      } else {
        callback()
      }
    }

    return {
      currentStep: 0,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: { required: true, message: '请输入原密码', trigger: 'change' },
        newPassword: { required: true, validator: validateNewPassword, trigger: 'change' },
        confirmPassword: { required: true, validator: validateConfirmPassword, trigger: 'change' }
      }
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    }
  },

  methods: {
    changePassword (cb) {
      this.$store.dispatch('changePassword', {
        params: { userId: this.user.id },
        body: {
          password: this.form.oldPassword,
          newPassword: this.form.newPassword,
          newPasswordConfirm: this.form.confirmPassword
        }
      }).then(response => {
        cb && cb()
      })
    },

    submit (cb) {
      this.$refs.form.validate(valid => {
        if (valid) {
          cb && cb()
        }
      })
    },

    messageSuccess () {
      this.$alert('修改密码成功，请重新登录！', '修改密码成功', {
        confirmButtonText: '重新登录',
        type: 'success',
        showClose: false,
        callback: action => {
          this.$store.dispatch('logout').then(() => {
            this.$router.push({ name: 'Login' })
          })
        }
      })
    },

    handleBtnSubmitClick () {
      this.submit(() => {
        this.changePassword(() => {
          this.messageSuccess()
        })
      })
    }
  }
}
</script>

<style lang="scss">
.page-setting-personal-password {
  min-height: 100%;
  background-color: #fff;

  &__form {
    padding: 30px 0;

    .el-form-item.is-required .el-form-item__label:before {
      font-family: sans-serif;
    }

    .el-input {
      width: 370px;
    }

    .el-button {
      width: 120px;
    }
  }

  &__success {
    padding: 30px 0;

    .app-svg-icon {
      width: 30px;
      height: 30px;
      color: #67c23a;
    }

    > span {
      margin-left: 10px;
      color: #999;
      font-size: 16px;
    }
  }
}
</style>
